module.exports = __webpack_public_path__ + "static/media/logow1.576bfb88.png";